<template>
  <div id="shops-list-component">
    <div class="cards row row-cards">
      <template v-if="isNotFound(items) && !busy">
        <span class="items-not-found">Ничего не найдено</span>
      </template>
      <template v-else>
        <div class="col-md-6 col-lg-3" v-for="item in items" :key="row.getShopId(item)">
          <router-link :to="{ name: 'PromocodesPostsShop', params: { channel_id: 1 }, query: { shop_id: row.getShopId(item) } }" class="edit-post toggle-show-post">
            <div class="card">
              <div class="card-body p-2 text-center">
                <span class="avatar avatar-xl mb-2 mt-2" :style="{ backgroundImage: 'url(' + row.getImage(item, 300) + ')' }">
                </span>
                <div class="m-0 mb-2">
                  <div class="title">{{ row.getShopName(item) }}</div>
                  <div
                      class="source-list"
                  >
                    <span class="item" v-for="source in row.getSources(item)" :key="row.getSourceId(source)">
                      <img class="img-round" alt="" :title="row.getSourceName(source)" :src="row.getSourceImage(source)">
                    </span>
                  </div>
                </div>
                <div class="mb-2">
                  <span class="badge bg-black-lt" v-show="row.hasLinked(item)">Новые: {{ row.getCntCouponNotParsed(item) }}</span>
                  <span class="badge bg-green-lt">Активные: {{ row.getCntCouponPublished(item) }}</span>
                  <span class="badge bg-red-lt" v-show="row.hasLinked(item)">На удаление: {{ row.getCntCouponDelst(item) }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </template>
      <div class="loader-posts">
        <div class="spinner-border" v-show="busy"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref, watch} from "vue"
import element from "@/modules/promocodes/pages/shops/components/list/services/element"
import Image from "@/services/Image"
import Helper from "@/services/Helper"
import Api from "@/modules/promocodes/pages/shops/services/Api"

export default defineComponent({
  name: "List",
  props: {
    query: {
      type: Object,
      required: true
    },
    clearResult: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {emit}) {
    let busy = ref(false)
    let items = ref([])
    let eofItems = ref(false)
    let countItems = ref(0)

    let row = {
      getShopId: (item) => {
        return element.getShopId(item)
      },

      getShopName: (item) => {
        return element.getShopName(item)
      },

      getImage: (item, w) => {
        let image = element.getImage(item)

        if (image !== null) {
          return getImage(image["host"], image["name"], w)
        } else {
          return getImage(null, null, w)
        }
      },
      hasLinked: (item) => {
        let sourceId = element.getSourceId(item)
        return sourceId > 0
      },
      getSources: (item) => {
        return element.getSources(item)
      },
      getSourceId: (item) => {
        return element.getSourceId(item)
      },
      getSourceName: (item) => {
        return element.getSourceName(item)
      },
      getSourceImage: (item) => {
        let sourceId = element.getSourceId(item)
        let sourceImage = ""

        switch (sourceId) {
          case 1: sourceImage = "/assets/static/sources/admitad.svg"
          break
          case 2: sourceImage = "/assets/static/sources/advcake.svg"
          break
        }
        return sourceImage
      },
      getActive: (item) => {
        return element.getActive(item)
      },
      getCampaignId: (item) => {
        return element.getCampaignId(item)
      },
      getCampaignName: (item) => {
        return element.getCampaignName(item)
      },
      getCntCouponParsed: (item) => {
        return element.getCntCouponParsed(item)
      },
      getCntCouponNotParsed: (item) => {
        return element.getCntCouponNotParsed(item)
      },
      getCntCouponPublished: (item) => {
        return element.getCntCouponPublished(item)
      },
      getCntCouponCanceled: (item) => {
        return element.getCntCouponCanceled(item)
      },
      getCntCouponDelst: (item) => {
        return element.getCntCouponDelst(item)
      },
    }

    function isNotFound(items) {
      return Helper.isEmptyObject(items)
    }

    function getImage(host, name, w = null, h = null) {
      return Image.handle(host, name, w, h)
    }

    watch(() => props.query, (query) => {
      busy.value = true

      if (props.clearResult) {
        clearResult()
      }

      load(query)
    })

    function clearResult() {
      eofItems.value = false
      countItems.value = 0
      items.value = []
    }

    function load(query, offset = null) {
      if (offset !== null) {
        query.offset = offset;
      }

      Api.items(query).then((resp) => {
        let data = resp.data

        items.value.push(...data.data)

        if (data.data.length === 0) {
          eofItems.value = true
        }

        countItems.value = data.count
      }).finally(() => {
        busy.value = false

        emit("onRender", {
          "oef_items": eofItems.value,
          "count_items": countItems.value
        })
      })
    }

    return {
      busy,
      items,
      row,
      isNotFound,
    }
  }
})
</script>

<style scoped src="./css/style.css"></style>
